export default __webpack_public_path__ + "static/media/defaultNewsImage.1af918c2.svg";